var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarouselBusinessTrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 22.7251L57.025 27.1001C58.8 27.4751 60 28.9751 60 30.7501V56.2501C60 58.3251 58.325 60.0001 56.25 60.0001H33.75C34.45 60.0001 35 59.4501 35 58.7501V57.5001H56.25C56.925 57.5001 57.5 56.9501 57.5 56.2501V30.7501C57.5 30.1751 57.1 29.6501 56.525 29.5251L35 25.2751V22.7251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.75 35C49.45 35 50 35.55 50 36.25C50 36.95 49.45 37.5 48.75 37.5H43.75C43.05 37.5 42.5 36.95 42.5 36.25C42.5 35.55 43.05 35 43.75 35H48.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.75 42.5C49.45 42.5 50 43.05 50 43.75C50 44.45 49.45 45 48.75 45H43.75C43.05 45 42.5 44.45 42.5 43.75C42.5 43.05 43.05 42.5 43.75 42.5H48.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.75 50C49.45 50 50 50.55 50 51.25C50 51.95 49.45 52.5 48.75 52.5H43.75C43.05 52.5 42.5 51.95 42.5 51.25C42.5 50.55 43.05 50 43.75 50H48.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 58.7501C35 59.4501 34.45 60.0001 33.75 60.0001C33.05 60.0001 32.5 59.4501 32.5 58.7501V57.5001V23.7501C32.5 23.3751 32.675 23.0251 32.95 22.7751C33.25 22.5501 33.625 22.4501 34 22.5251L35 22.7251V25.2751V57.5001V58.7501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 57.5V58.75C32.5 59.45 33.05 60 33.75 60H23.75C24.45 60 25 59.45 25 58.75V57.5H32.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 12.5C26.95 12.5 27.5 13.05 27.5 13.75C27.5 14.45 26.95 15 26.25 15H21.25C20.55 15 20 14.45 20 13.75C20 13.05 20.55 12.5 21.25 12.5H26.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 21.25C27.5 21.95 26.95 22.5 26.25 22.5H21.25C20.55 22.5 20 21.95 20 21.25C20 20.55 20.55 20 21.25 20H26.25C26.95 20 27.5 20.55 27.5 21.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 27.5C26.95 27.5 27.5 28.05 27.5 28.75C27.5 29.45 26.95 30 26.25 30H21.25C20.55 30 20 29.45 20 28.75C20 28.05 20.55 27.5 21.25 27.5H26.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 35C26.95 35 27.5 35.55 27.5 36.25C27.5 36.95 26.95 37.5 26.25 37.5H21.25C20.55 37.5 20 36.95 20 36.25C20 35.55 20.55 35 21.25 35H26.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 36.25C15 36.95 14.45 37.5 13.75 37.5H8.75C8.05 37.5 7.5 36.95 7.5 36.25C7.5 35.55 8.05 35 8.75 35H13.75C14.45 35 15 35.55 15 36.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 12.5C14.45 12.5 15 13.05 15 13.75C15 14.45 14.45 15 13.75 15H8.75C8.05 15 7.5 14.45 7.5 13.75C7.5 13.05 8.05 12.5 8.75 12.5H13.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 20C14.45 20 15 20.55 15 21.25C15 21.95 14.45 22.5 13.75 22.5H8.75C8.05 22.5 7.5 21.95 7.5 21.25C7.5 20.55 8.05 20 8.75 20H13.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 27.5C14.45 27.5 15 28.05 15 28.75C15 29.45 14.45 30 13.75 30H8.75C8.05 30 7.5 29.45 7.5 28.75C7.5 28.05 8.05 27.5 8.75 27.5H13.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 46.25C22.5 45.55 21.925 45 21.25 45H13.75C13.05 45 12.5 45.55 12.5 46.25V57.5H10V46.25C10 44.175 11.675 42.5 13.75 42.5H21.25C23.325 42.5 25 44.175 25 46.25V57.5H22.5V46.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 57.5H22.5H25V58.75C25 59.45 24.45 60 23.75 60H11.25C10.55 60 10 59.45 10 58.75V57.5H12.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375 0.500088L31.85 4.67509C33.675 4.97509 35 6.52509 35 8.37509V22.7251L34 22.5251C33.625 22.4501 33.25 22.5501 32.95 22.7751C32.675 23.0251 32.5 23.3751 32.5 23.7501V8.37509C32.5 7.75009 32.05 7.22509 31.45 7.12509L3.975 2.97509C3.9 2.95009 3.825 2.95009 3.75 2.95009C3.45 2.95009 3.175 3.05009 2.95 3.25009C2.65 3.50009 2.5 3.82509 2.5 4.20009V56.2501C2.5 56.9501 3.075 57.5001 3.75 57.5001H10V58.7501C10 59.4501 10.55 60.0001 11.25 60.0001H3.75C1.675 60.0001 0 58.3251 0 56.2501V4.20009C0 3.10009 0.475 2.05009 1.325 1.35009C2.175 0.625089 3.275 0.325088 4.375 0.500088Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselBusinessTrade);
export default __webpack_public_path__ + "static/media/carouselBusinessTrade.99a7b5fb7c6d5d3564dd9c6a5093886a.svg";
export { ForwardRef as ReactComponent };